module.exports = __webpack_public_path__ + "img/Absa.5496b5fb.svg";